// removed by extract-text-webpack-plugin
module.exports = {"voyager-logo":"header__voyager-logo","idl-logo":"header__idl-logo","header":"header__header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.scss
// module id = 1227
// module chunks = 0